// extracted by mini-css-extract-plugin
export default {"box":"model-viewer-fullscreen-bottom-panel_box__7Grgh","controls":"model-viewer-fullscreen-bottom-panel_controls__58LNk"};